import { Component } from 'react';
import PropTypes from 'prop-types';

class Timer extends Component {
  componentDidMount() {
    this.idleTime = 0;
    document.addEventListener('click', this.resetIdleTime);
    document.addEventListener('mousemove', this.mouseMove);

    this.timer = setInterval(() => {
      this.idleTime += 1;
      if (this.idleTime > this.props.waitingTime) {
        this.props.onTimeout();
      }
    }, this.props.delay * 1000);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.resetIdleTime);
    document.removeEventListener('mousemove', this.mouseMove);
    clearInterval(this.timer);
  }

  mouseMove = () => {
    clearTimeout(this.mouseMoved);
    this.mouseMoved = setTimeout(this.resetIdleTime, 200);
  }

  resetIdleTime = () => {
    this.idleTime = 0;
  }

  render() {
    return this.props.children;
  }
}

Timer.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
  onTimeout: PropTypes.func.isRequired,
  waitingTime: PropTypes.number.isRequired,
};

Timer.defaultProps = {
  delay: 1,
};

export default Timer;
